<nav class="navbar navbar-expand-lg bg-primary fixed-top" data-bs-theme="dark">
  <div class="container-fluid">
    <button
      class="btn btn-outline-light border-0 me-2 menu-toggle"
      type="button"
      aria-label="Mostrar u ocultar menú lateral"
      [attr.aria-expanded]="sidebarState.visible()"
      (click)="sidebarState.toggle()"
    >
      <i class="bi bi-list fs-4"></i>
    </button>
    <a class="navbar-brand" href="#">Gestion</a>
    <button
      class="navbar-toggler"
      type="button"
      data-bs-toggle="collapse"
      data-bs-target="#wgNavbarSupportedContent"
      aria-controls="wgNavbarSupportedContent"
      aria-expanded="false"
      aria-label="Toggle navigation"
    >
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="wgNavbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item">
          <a class="nav-link active" aria-current="page" routerLink="/working/dashboard">Inicio</a>
        </li>
      </ul>
      <div class="d-flex align-items-center gap-2">
        @if (authSession.isAuthenticated()) {
          @if (authSession.getUserName(); as userName) {
            <span class="navbar-text text-white border border-light rounded px-2 py-1">{{ userName }}</span>
          }
          @if (sessionTimer.remainingTime(); as remainingTime) {
            <span class="navbar-text text-white border border-light rounded px-2 py-1"><i class="bi bi-clock me-1"></i>{{ remainingTime }}</span>
          }
        }
        <app-theme-toggle></app-theme-toggle>
        <a class="btn btn-outline-light" routerLink="/portal/home">Portal</a>
        <button class="btn btn-outline-light" type="button" (click)="logout()">Cerrar Sesión</button>
      </div>
    </div>
  </div>
</nav>
